module.exports = __webpack_public_path__ + "static/media/broomhandle.c4665e97.png";